import React, { useRef, useState } from "react"
import { Container } from "reactstrap"
import Slider from "react-slick"

import file from "../../images/law.png"
import arrow from "../../images/arrow-bottom.svg"

import Ticker from "../ticker"
import Animate from "../animate"

const list = [
  {
    title: "Компания ликвидирована без налоговой проверки",
    image: "/images/cases/case-1.jpg",
    percents: "+100%",
    totalValue: 42319836,
    fileUrl: "files/aronov_i_partnery_case_1.pdf"
  },
  {
    title: "Компания ликвидирована без налоговой проверки",
    image: "/images/cases/case-2.jpg",
    totalValue: 1770662,
    percents: "+100%",
    fileUrl: "files/aronov_i_partnery_case_2.pdf"
  },
  {
    title: "Компания ликвидирована без налоговой проверки",
    image: "/images/cases/case-3.jpg",
    totalValue: 3064216,
    percents: "+100%",
    fileUrl: "files/aronov_i_partnery_case_3.pdf"
  }
]

const CasesSection = ({ title }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
          afterChange: current => setActiveSlide(current)
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          arrows: false
        }
      }
    ]
  }

  const sliderCases = useRef()
  const [activeSlide, setActiveSlide] = useState(0)

  return (
    <section className="section section_cases" id="cases">
      <Container>
        <h2 className="section_title">{title}</h2>

        <div className="list">
          <div className="d-flex d-sm-none list_header">
            {list.map((_, i) => (
              <div
                key={i}
                role="button"
                tabIndex="-1"
                className={`list_item__counter ${
                  activeSlide === i ? "active" : ""
                }`}
                onClick={() => sliderCases.current.slickGoTo(i)}
                onKeyDown={() => sliderCases.current.slickGoTo(i)}
              >
                0{i + 1}
              </div>
            ))}
          </div>
          <Slider
            {...settings}
            className="slider row"
            ref={slider => (sliderCases.current = slider)}
          >
            {list.map((item, i) => (
              <div className="col list_item slider_item" key={i}>
                <Animate className={`slide-up delay-${i + 1}`}>
                  <>
                    <div className="list_item__counter d-none d-sm-block">
                      0{i + 1}
                    </div>
                    <h4 className="list_item__title">{item.title}</h4>
                    <div className="list_item__image">
                      <img src={item.image} alt="cases" width="300px" />
                    </div>
                    {item.description && (
                      <div className="list_item__description ">
                        {item.description}
                      </div>
                    )}
                    <div className="list_item__info">
                      {item.value !== undefined && (
                        <div className="list_item__row">
                          <h5>
                            {item.valueTitle || "Заявленные требования, руб"}
                          </h5>
                          <div className="list_item__value">
                            <Ticker end={item.value} duration={1} />
                          </div>
                          <img
                            src={arrow}
                            width="40px"
                            alt="arrow"
                            className="list_item__arrow"
                          />
                        </div>
                      )}

                      {item.totalValue !== undefined && (
                        <div className="list_item__row">
                          <h5>
                            {item.totalValueTitle ||
                              "Списана задолженность, руб"}
                          </h5>
                          <div className="list_item__value">
                            <Ticker end={item.totalValue} />
                          </div>
                          {item.percents && (
                            <div className="list_item__hint">
                              {item.percents}
                            </div>
                          )}
                        </div>
                      )}
                      <div className="list_item__row">
                        {item.fileUrl && (
                          <div className="file">
                            <a href={item.fileUrl}>
                              <div className="file__icon">
                                <img src={file} width="34px" alt="file" />
                              </div>
                              <div className="file__title">
                                Смотреть <br />
                                дело
                              </div>
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                </Animate>
              </div>
            ))}
          </Slider>
        </div>
      </Container>
    </section>
  )
}

export default CasesSection
